import { create } from 'zustand';

type Props = {
  // 앱 초기 로딩, 새로고침 시
  isInitialLoading: boolean;
  setInitialLoading: (isInitialLoading: boolean) => void;

  // 지도 getMapData
  hasMapData: boolean;
  setHasMapData: (hasMapData: boolean) => void;

  // 지도 showMap
  isLoadingMap: boolean;
  setLoadingMap: (isLoadingMap: boolean) => void;

  // 지도 층 변경 로딩
  isFloorChanging: boolean;
  setFloorChanging: (isFloorChanging: boolean) => void;

  // 길안내 액션 로딩
  isActionLoading: boolean;
  setActionLoading: (value: boolean) => void;

  // 모의 주행
  isNavi: boolean;
  setNavi: (isNavi: boolean) => void;
};

const useLoadingStore = create<Props>((set, get) => ({
  isInitialLoading: true,
  setInitialLoading(isInitialLoading: boolean) {
    set(() => ({ isInitialLoading }));
  },

  hasMapData: false,
  setHasMapData(hasMapData: boolean) {
    set(() => ({ hasMapData }));
  },

  isLoadingMap: true,
  setLoadingMap(isLoadingMap: boolean) {
    set(() => ({ isLoadingMap }));
  },

  isFloorChanging: false,
  setFloorChanging(isFloorChanging: boolean) {
    set(() => ({ isFloorChanging }));
  },

  isActionLoading: false,

  setActionLoading(isActionLoading: boolean) {
    set(() => ({ isActionLoading }));
  },

  isNavi: false,
  setNavi(isNavi: boolean) {
    set(() => ({ isNavi }));
  },
}));

export default useLoadingStore;
